<template>
  <el-row>
    <el-col :span="24">
      <el-form-item label="产品" prop="product" class="edit-label">
        <el-select
          v-model="SelectProducts"
          filterable
          :clearable="true"
          multiple
          placeholder="输入以搜索"
          class="edit-select"
          v-loading="loading"
          @change="change"
          :disabled="disabled"
        >
          <el-option
            v-for="item in productList"
            :key="item.id"
            :label="item.product_name"
            :value="item.id"
            :disabled="item.status !== 1"
          />
        </el-select>
      </el-form-item>
    </el-col>
    <el-col :span="24">
      <el-form-item label="科室" class="edit-label">
        <el-select
          v-model="SelectDepartments"
          filterable
          multiple
          placeholder="输入以搜索"
          :clearable="true"
          class="edit-select"
          v-loading="loading"
          :disabled="disabled"
        >
          <el-option
            v-for="item in departmentList"
            :key="item.department_id"
            :label="item.department_name"
            :value="item.department_id"
          />
        </el-select>
      </el-form-item>
    </el-col>
    <el-col :span="24" v-for="label in labelList" :key="label.id" v-show="showLabel(label)">
      <el-form-item :label="label.GroupName" class="edit-label">
        <el-select
          v-model="label.selectValue"
          :clearable="true"
          filterable
          multiple
          placeholder="输入以搜索"
          class="edit-select"
          @change="change"
          v-loading="loading"
          :disabled="disabled"
        >
          <el-option
            v-for="value in label.LabelList"
            :key="value.Id"
            :label="value.LabelName"
            :value="value.Id"
            :disabled="value.Status !== 1"
          />
        </el-select>
        <el-button
          v-show="!disabled"
          type="text"
          style="margin-left: 20px"
          @click="removeLabel(label)"
        >
          删除
        </el-button>
      </el-form-item>
    </el-col>
    <el-button v-show="!disabled" type="text" @click="dialogLabelManageVisible = true">
      添加标签分类
    </el-button>
    <el-dialog :visible.sync="dialogLabelManageVisible" width="500px" title="标签分类管理">
      <el-checkbox-group v-model="labelCheckList">
        <div v-for="label in labelList" :key="label.id" style="margin: 10px 0">
          <el-checkbox :label="label.GroupName" :value="label.GroupName"></el-checkbox>
          {{ label.GroupName }}
        </div>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogLabelManageVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleChangeLabel">确 定</el-button>
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
import { GetAllLabelInfoList } from '@/api/releaseManagement';
import { getHospitalDepartmentListApi } from '@/api/setUp';
import { GetProductInfoList } from '@/api/setUser';

export default {
  name: 'LabelSelect',
  props: {
    tags: {
      type: Array,
      default: () => [],
    },
    // 最大可选标签数量（产品+自选，不含科室）
    labelAmount: {
      type: Number,
      default: 20,
    },
    // 是否禁用 (如查看详情不可编辑)
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      products: [], // 产品回显
      departments: [], // 科室回显

      productList: [], // 产品列表
      departmentList: [], //  科室列表

      labelList: [], // 标签列表
      labelCheckList: [], // 选择的标签

      dialogLabelManageVisible: false, // 标签管理的dialog
      loading: false,

      SelectProducts: [],
      SelectDepartments: [],
    };
  },
  computed: {
    showLabel() {
      return (label) => {
        return label.show;
      };
    },
  },
  watch: {
    tags: {
      handler(tags) {
        this.setSelect(tags);
      },
    },
  },
  created() {
    // 查询所有的动态标签
    GetAllLabelInfoList()
      .then((res) => {
        // console.log(res);
        this.labelList = res.LabelGroupList;
        this.labelList.forEach((item, index) => {
          item.id = index;
        });
        for (const label of this.labelList) {
          label.show = false;
        }
      })
      .catch((e) => {
        this.$message.error(e);
      });

    // 查询科室列表
    getHospitalDepartmentListApi()
      .then((res) => {
        this.loading = false;
        this.departmentList = res.data;
      })
      .catch(() => {
        this.loading = false;
        this.$message('查询失败');
      });

    // 查询产品标签
    GetProductInfoList({})
      .then((res) => {
        this.productList = res.list;
      })
      .catch((e) => {
        this.$message.error(e);
      });
  },
  mounted() {
    this.SelectDepartments = this.departments;
    this.SelectProducts = this.products;
    this.setSelect(this.tags);
  },
  methods: {
    setSelect(tags) {
      this.loading = true;
      for (const tag of tags) {
        if (tag.TagType === 1) {
          this.products.push(tag.TagId);
        } else if (tag.TagType === 2) {
          this.departments.push(String(tag.TagId));
        } else if (tag.TagType === 3) {
          for (const label of this.labelList) {
            const valueList = label.LabelList.map((temp) => temp.Id);
            if (valueList.includes(tag.TagId)) {
              label.show = true;
              this.labelCheckList.push(label.GroupName);
              label.selectValue.push(tag.TagId);
              break;
            }
          }
        }
      }
      this.loading = false;
    },
    handleChangeLabel() {
      for (const label of this.labelList) {
        label.show = this.labelCheckList.includes(label.GroupName);
        if (!label.show) {
          label.selectValue.splice(0, this.labelAmount);
        }
      }
      this.$forceUpdate();
      this.dialogLabelManageVisible = false;
    },
    removeLabel(label) {
      this.$set(label, 'show', false);
      label.selectValue.splice(0, this.labelAmount);
      this.labelCheckList.splice(this.labelCheckList.indexOf(label.GroupName), 1, 0);
    },
    change(obj) {
      // console.log(obj);
      // 标签数量=产品+自选，不含科室
      let amount = this.SelectProducts.length;
      for (const label of this.labelList) {
        if (label.show) {
          amount += label.selectValue.length;
        }
      }
      if (amount > this.labelAmount) {
        obj.pop();
        this.$message.warning(`标签数量不能多于${this.labelAmount}个`);
      }
    },
    // 供外界查询是否已经填了产品
    hasNoProduct() {
      return this.SelectProducts.length === 0;
    },
    commitTags() {
      const valueList = [];
      // 产品标签
      for (const product of this.SelectProducts) {
        valueList.push({
          TagId: Number(product),
          TagType: 1,
        });
      }
      // 科室标签
      for (const department of this.SelectDepartments) {
        valueList.push({
          TagId: Number(department),
          TagType: 2,
        });
      }
      // 动态标签
      for (const label of this.labelList) {
        if (label.show) {
          for (const value of label.selectValue) {
            valueList.push({
              TagId: Number(value),
              TagType: 3,
            });
          }
        }
      }
      // console.log(valueList);
      return valueList;
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-label {
  width: 100%;
  .edit-select {
    width: 400px;
  }
}
</style>
